'use strict';

import React, {PropTypes} from 'react';
import { connect } from 'react-redux';

export default function ContactSubNavigation(props) {

  return (
    <div className='contact-sub-navigation'>
      <h3>{props.title}</h3>
      {
        props.children
      }
    </div>
  );
}



// WEBPACK FOOTER //
// ./shared/react/client/SubNavigation/index.js